/**
 * Config is the overall config for the widget / editor
 * - what environment we're in
 * - global options like a debug flag
 */
import utils from './utils.js';

// window CDC_CONFIG obect, available on front end
const cdcWebConfig = Object.assign({}, window.CDC_CONFIG, window.CDC?.config);

// window CDC_POST object, available on front end
const cdcPost = Object.assign({}, window.CDC_POST);

const isLocal = ('localhost' === location.hostname);

// figure the path to local wcms
const wcmsRoot = (() => {
	if (isLocal) {
		// default site
		return '//vvv.wcms/';
	}
	return utils.unTrailingSlashit(String(location.href).replace(/\/[^\/]+\/wp\-admin.*/, '')) + '/';
})();

let siteId = isLocal ? utils.getParam('site_id') : 0;
let postId = null;

// if in WCMS, use CDC SCRIPT VARS
if (!siteId && window.CDC_SCRIPT_VARS?.site_id) {
	siteId = utils.getWCMSSiteId(window.CDC_SCRIPT_VARS.site_id);
}
// on front end, use CDC_POST
if (window.CDC_POST?.id) {
	postId = window.CDC_POST.id;
	siteId = utils.getWCMSSiteId(window.CDC_POST.id)
}
// finally sanitize siteId to string
siteId = utils.getWCMSSiteId(siteId);

const config = {
	siteId,
	postId,
	postTax: cdcPost.tax,
	wcmsRoot,
	wcmsHost: wcmsRoot ? utils.parseUrl(wcmsRoot).host : '',
	debug: utils.getParamSwitch('cdcdebug', false),
	language: (document.documentElement && document.documentElement.lang) || 'en-us', // isBrowser &&
	solrURL: 'https://search.cdc.gov/srch/internet_wcms/select', // full override of host and path
	solrURLInternal: null, // full override of host and path
	taxURL: 'https://www.cdc.gov/config/tax',
	basePath: 'http://vvv.wcms',
	crossdomain: false,
	pageSize: 10,
	display: {
		dateformat: 'MMM D, YYYY',
		altDateFormat: 'MMMM D, YYYY',
		contentSize: 230,
	},
	wpApiPath: '/wp-json/cdc/v2/',
};

// extend from window object to update config
if (cdcWebConfig) {
	config.solrURL = cdcWebConfig.solr;
	config.taxURL = cdcWebConfig.tax;
	if (cdcWebConfig.solr_internal) {
		config.solrURLInternal = cdcWebConfig.solr_internal;
	}
	if (cdcWebConfig.solr_beta) {
		config.solrURLBeta = cdcWebConfig.solr_beta;
	}
}

if ( 'es-us' === config.language.toLowerCase() ) {
	config.taxURL = config.taxURL += '/es';
}

if (config.debug) {
	console.info('cfg:', config);
}

// computed
config.isEnglish = 'en-us' === config.language;

export default config;
